import React, { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@parentsquare/squarekit/lib/utils';

const skeletonVariants = cva('tw:animate-pulse', {
  variants: {
    version: {
      v1: '',
    },
    variant: {
      default: '',
    },
  },
  compoundVariants: [
    {
      version: 'v1',
      variant: 'default',
      class: 'tw:rounded-[var(--radius-6)] tw:bg-[var(--color-surface-muted)]',
    },
  ],
  defaultVariants: {
    version: 'v1',
    variant: 'default',
  },
});

type SkeletonProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof skeletonVariants> & {
    version?: 'v1';
  };

function Skeleton({ className, version, variant, ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        skeletonVariants(version !== undefined ? { version, variant } : { variant }),
        className
      )}
      {...props}
    />
  );
}

export { Skeleton, skeletonVariants };
